import { McoEndpointBuilder } from "./apiSlice"
import { apiClient } from "./useApi"
import { ApiTag } from "./util/ApiTag"

const eventLogEndpoints = (build: McoEndpointBuilder) => ({
	eventLogGetEventLogs: build.query({
		queryFn: apiClient.eventLog.getEventLog,
		providesTags: [ApiTag.Tenant]
	})
})

export default eventLogEndpoints
